export const buildenv = {
  deployedAt: '2025-04-08T12:36:10.040Z',
  release: 'f710aa5fd0c94878a2da30fc703dc59267e6d2ca',
}
